import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectIsLoading } from "redux-toolkit/promises/selectors";
import { updatePromiseAsync } from "redux-toolkit/promises/actions";

const useUpdatePromise = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectIsLoading);

  const updatePromise = useCallback(
    (id, data) => {
      dispatch(updatePromiseAsync({ id, data }));
    },
    [dispatch],
  );

  return {
    isLoading,
    updatePromise,
  };
};

export default useUpdatePromise;
